import { render, staticRenderFns } from "./ModalStudentHandedData.vue?vue&type=template&id=ad3988a6&scoped=true"
import script from "./ModalStudentHandedData.vue?vue&type=script&lang=js"
export * from "./ModalStudentHandedData.vue?vue&type=script&lang=js"
import style0 from "./ModalStudentHandedData.vue?vue&type=style&index=0&id=ad3988a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3988a6",
  null
  
)

export default component.exports